module.exports = __webpack_public_path__ + "img/brouilles-blanc-off.bd8dae8b.svg";